export const getDaysTogetherText = (date: string | null): string => {
    if (!date) return '∞ дней вместе';
    
    const start = new Date(date);
    const now = new Date();
    start.setHours(0, 0, 0, 0);
    now.setHours(0, 0, 0, 0);
    const diff = Math.floor((now.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
    
    const lastDigit = diff % 10;
    const lastTwoDigits = diff % 100;
    let dayWord = 'дней';
    if (lastTwoDigits < 11 || lastTwoDigits > 14) {
        if (lastDigit === 1) dayWord = 'день';
        else if (lastDigit >= 2 && lastDigit <= 4) dayWord = 'дня';
    }

    return `${diff} ${dayWord} вместе`;
};
